import React, {useEffect, useState} from "react";
import {useArticleForm} from "../../hooks/use-article-form.hook";
import ArticleTag from "../ui/article-tag";
import AppButton from "@common/components/app-button";
import {ReactComponent as PlusIcon} from "@assets/icons/plus.svg";
import {useFormContext} from "react-hook-form";

const Tags = () => {
    const {form, formData, updateStepData} = useArticleForm();
    const [isAddingTag, setIsAddingTag] = useState(false);
    const [newTagValue, setNewTagValue] = useState("");
    const {formState: {errors}} = useFormContext();

    const handleAddTag = () => {
        if (newTagValue.trim() && !formData?.tags?.includes(newTagValue.trim())) {
            const currentTags = formData?.tags || [];
            const updatedTags = [...currentTags, newTagValue.trim()];
            form.setValue('tags', updatedTags);
            updateStepData('content' as any, {tags: updatedTags});
        }
        setIsAddingTag(false);
        setNewTagValue("");
    };

    const handleRemoveTag = (tagToRemove: string) => {
        const currentTags = formData?.tags || [];
        const updatedTags = currentTags.filter(tag => tag !== tagToRemove);
        form.setValue('tags', updatedTags);
        updateStepData('content' as any, {tags: updatedTags});
    };

    const handleCancelAdd = () => {
        setNewTagValue("");
        setIsAddingTag(false);
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleAddTag();
        } else if (e.key === 'Escape') {
            handleCancelAdd();
        }
    };

    return (
        <div className="space-y-2">
            <h4 className="text-sm font-normal text-on-surface/60">Tagi</h4>
            <div className="flex flex-wrap gap-2">
                {formData?.tags?.map((tag, index) => (
                    <ArticleTag
                        key={index}
                        text={tag}
                        readonly={false}
                        onCancel={() => handleRemoveTag(tag)}
                    />
                ))}

                {isAddingTag ? (
                    <div
                        className="inline-flex items-center bg-surface-level-1 hover:bg-on-surface/5 border border-outline rounded-lg text-sm font-semibold h-[32px] px-3">
                        <input
                            type="text"
                            value={newTagValue}
                            onChange={(e) => setNewTagValue(e.target.value)}
                            onKeyDown={handleKeyPress}
                            onBlur={handleAddTag}
                            autoFocus
                            className="appearance-none bg-transparent outline-none min-w-[80px] w-auto"
                            placeholder="Wpisz tag..."
                            style={{ width: `${Math.max(50, newTagValue.length * 8 + 2)}px` }}
                        />
                    </div>
                ) : (
                    <AppButton
                        onClick={() => setIsAddingTag(true)}
                        classNameContentWrapper="w-full h-full flex-1"
                        className="hover:bg-on-surface/5 bg-surface-level-1 inline-block w-8 h-8 rounded-lg border border-outline"
                    >
                        <div className="flex items-center justify-center h-full w-full">
                            <PlusIcon/>
                        </div>
                    </AppButton>
                )}
            </div>
            <div>
                {errors["tags"] && <p className="text-red-500 text-xs pt-1">{'' + errors["tags"]?.message}</p>}
            </div>
        </div>
    )
}

export default Tags
